import { Component, ViewEncapsulation, Input } from '@angular/core';
import { ResortSummary } from '../../models/presentation.model';
import { Core, OvsComponent, QueryParamService } from '../../shared/core/ovs.core';
import { Coordinates } from '../../shared/geo/ovs.geocoding';
import { ResortComponent } from '../../shared/resort.component';
import { fadeInAnimation } from '../../shared/animations';
import { DistanceInfo } from '../distance-info.model';
import { AppInsightsService } from 'microsoft-applicationinsights-angular5';
import { SearchResultEvents } from '../../instrumentation/resort-custom-events';
import * as moment from 'moment';
import { Router } from '@angular/router';
import { UserActivityLogger, UserActivityLoggerOptions } from '../../instrumentation/user-activity-logger.service';

@Component({
    selector: 'resort-listing-preferred',
    templateUrl: './resort-listing-preferred.component.html',
    styleUrls: ['./resort-listing-preferred.component.scss'],
    animations: [fadeInAnimation],
    host: { '[@fadeInAnimation]': '' },
    encapsulation: ViewEncapsulation.None
})
export class ResortListingPreferredComponent extends ResortComponent
{
    @Input()
    public startDate: Date;
    @Input()
    public resort: ResortSummary = new ResortSummary();
    @Input()
    public geometry: Coordinates;
    @Input()
    public distanceInfo: DistanceInfo;
    public content: string;
    private _core: Core;

    constructor(private qryParamService: QueryParamService, private router: Router, core: Core){
        super();
        this._core = core;
    }

    protected initialize(): void {
        super.initialize();

        this.getResortCreditDescription();
    }

    public get hasDiscount() : boolean{
        return (this.resort.startingFromPurchase - this.resort.startingFromDiscount) >=1 ;
    }

    public get savingsPercentRate(): number{
        if(this.resort.startingFromPurchase > 0 )
        {
            return Math.floor((1 - (this.resort.startingFromDiscount/this.resort.startingFromPurchase)) *100);
        }
        return 0;
    }

    public get showDiscountBadge(): boolean {
        if ((this.resort.startingFromPurchase - this.resort.startingFromDiscount) >= 1){
            if (this.resort.startingFromPurchase > 0) {
                if (Math.floor((1 - (this.resort.startingFromDiscount / this.resort.startingFromPurchase)) * 100) >= 1) {
                    return true;
                }
            }
        }
        return false;
    }

    public get hasEarnReward(): boolean{
        return this.resort.rewardsUpTo > 0;
      }

    public explore(): void {
        if (!this.startDate || this.startDate.toString() == "Invalid Date") {
            this.startDate = new Date(this.resort.checkInDate);

        }
        this.startDate.setDate(1) ;
        UserActivityLogger.logEvent(SearchResultEvents.ExploreButtonClicked
            , { resortId: this.resort.id, isPreferred: true, date: moment(this.startDate).format("MM/DD/YYYY") }
            , UserActivityLoggerOptions.AppInsightsOnly
        );
        this.qryParamService.resortDetailParams.resortId = this.resort.id;
        this.qryParamService.resortDetailParams.startDate = new Date(this.startDate);
        this.qryParamService.resortDetailParams.isExclusive = this.resort.isExclusive;
        this.qryParamService.store();
        this.router.navigate(['resort-detail'], { queryParams: { sid: this.qryParamService.encodedGuid } });
    }
    public onShowLandPrice(): boolean {
        return this.application.configuration.ShowPricing === false;
    }

    public hideResortCreditMessage(): boolean {
        return this._core.currentConfiguration.HideResortCreditMessage;
    }

    private getResortCreditDescription() {
        if (this.resort !== undefined &&
            this.resort !== null &&
            this.resort.resortCreditDetails !== undefined &&
            this.resort.resortCreditDetails !== null)
        {
            this.content = this.resort.resortCreditDetails;
        }
    }

    public convertToTextFromHtml(value : string) {
        return value.replace(/(<([^>]+)>)/ig, '');
    }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/Ovs.Resort.UI.Web/src/app/resort-listing/resort-listing-preferred/resort-listing-preferred.component.ts